var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("div", { staticClass: "wrapper", attrs: { id: "header_main" } }, [
        _c("div", { staticClass: "logo" }, [
          _c("img", {
            attrs: { src: this.getImage("common/logo.png") },
            on: {
              click: function($event) {
                _vm.onLogo()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "space",
          staticStyle: { "flex-shrink": "1" }
        }),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.onSelect()
                }
              }
            },
            [_vm._v("カテゴリから商品を選ぶ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.onGuide()
                }
              }
            },
            [_vm._v("ご利用ガイド")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.onSupport()
                }
              }
            },
            [_vm._v("お問い合わせ")]
          ),
          _vm._v(" "),
          !_vm.isLogin
            ? _c(
                "div",
                {
                  staticClass: "category",
                  on: {
                    click: function($event) {
                      _vm.route("DcOrderSignIn", { type: "hd" })
                    }
                  }
                },
                [_vm._v("会員登録/ログイン")]
              )
            : _c(
                "div",
                {
                  staticClass: "category",
                  on: {
                    click: function($event) {
                      _vm.route("DcMyPage")
                    }
                  }
                },
                [_vm._v("マイページ")]
              )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_area" }, [
          _c("div", { on: { click: _vm.goCart } }, [
            _c("img", { attrs: { src: _vm.dispCartImg } })
          ])
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "menu_area" } }, [
          _c(
            "div",
            {
              staticClass: "toggle",
              on: {
                click: function($event) {
                  _vm.onMenu()
                },
                mouseover: function($event) {
                  _vm.isOnMenu = true
                },
                mouseout: function($event) {
                  _vm.isOnMenu = false
                }
              }
            },
            [_c("span"), _c("span"), _c("span")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("dd-left-menu", {
        ref: "menuRef",
        class: { main_navi: true, active: _vm.isMenuActive },
        on: { close: _vm.close }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4608c8ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4608c8ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/common/DcHeader.vue
// module id = null
// module chunks = 